import { darken, saturate } from "polished";
import { color } from "./color";
export const activeColor = (prop) => (props) => darken(0.075, saturate(0.2, color(prop)(props)));
